import React, { useState } from "react";
import {
	Box,
	Button,
	Chip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	Stack,
	Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LinkIcon from "@mui/icons-material/Link";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import { QRCodeCanvas } from "qrcode.react";

export const InvitacionActividad = ({ open, setOpen, data }) => {
	const [copiado, setCopiado] = useState(false);
	const esComida = Number(data.id_tipo_evento) === 1;
	const esLimpieza = Number(data.id_tipo_evento) === 2;
	const ruta = esComida ? "accesorapidocomida" : (esLimpieza ? "accesorapidolimpieza" : "accesorapidoactividad");
	const enlace = `https://elpelobetxi.com/${ruta}/${data.id}`;
	const titulo = esComida ? "Menjar" : (esLimpieza ? "Neteja" : "Activitat");
	const InviteIcon = esComida ? RestaurantMenuIcon : (esLimpieza ? CleaningServicesIcon : LocalActivityIcon);

	const copiarEnlace = async () => {
		try {
			await navigator.clipboard.writeText(enlace);
			setCopiado(true);
			setTimeout(() => setCopiado(false), 2000);
		} catch (err) {
			console.error("Error en copiar l'enllaç", err);
		}
	};

	return (
		<Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
			<DialogTitle className="activity-invite-title">
				<Box className="activity-invite-icon">
					<InviteIcon />
				</Box>
				<Box className="activity-invite-heading">
					<Typography className="activities-eyebrow">Invitació</Typography>
					<Typography variant="h5" className="activity-invite-name">
						{data.asunto || titulo}
					</Typography>
				</Box>
			</DialogTitle>

			<DialogContent dividers className="activity-invite-content">
				<Box className="activity-invite-qr-panel">
					<Chip icon={<QrCode2Icon />} label="Accés ràpid" className="activities-stat-chip" />
					<Box className="activity-invite-qr">
						<QRCodeCanvas value={enlace} size={190} />
					</Box>
					<Typography className="activity-invite-hint">
						Escaneja el QR o comparteix l'enllaç per a confirmar l'assistència.
					</Typography>
				</Box>

				<Divider className="activity-invite-divider" />

				<Stack className="activity-invite-link-block">
					<Box className="activity-invite-link-label">
						<LinkIcon fontSize="small" />
						<Typography>Enllaç d'invitació</Typography>
					</Box>
					<Box className="activity-invite-link">
						<Typography>{enlace}</Typography>
					</Box>
					<Button
						variant="contained"
						startIcon={copiado ? <CheckCircleIcon /> : <ContentCopyIcon />}
						onClick={copiarEnlace}
						className="activity-invite-copy"
					>
						{copiado ? "Copiat" : "Copiar enllaç"}
					</Button>
				</Stack>
			</DialogContent>

			<DialogActions className="activity-invite-actions">
				<Button onClick={() => setOpen(false)} variant="outlined">
					Tancar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
